import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const AppLabelComponent = ({
  label = "",
  hideLabel = false,
  color,
  variant = "h5",
  justifyContent,
  align,
  gap = 1,
  children = null,
  required = false,
  icon = null,
  iconComponent = null,
  disabled = false,
}) => {
  return (
    <Stack
      rowGap={gap}
      justifyContent={justifyContent}
      alignItems={align}
      sx={{
        display: "flex",
        cursor: disabled ? "not-allowed" : "auto",
      }}
    >
      {!hideLabel && (
        <Box
          display="flex"
          flexDirection="row"
          alignItems={icon ? "center" : undefined}
          justifyContent={icon ? "space-between" : undefined}
          sx={{ p: 0, m: 0 }}
        >
          <Typography color={color} variant={variant}>
            {label} {required && <span style={{ color: "#dd1b06" }}>*</span>}
          </Typography>
          {icon && iconComponent}
        </Box>
      )}
      {disabled ? (
        <div
          style={{ pointerEvents: "none", width: "100%" }}
          tabIndex={-1}
          onKeyDown={(e) => e.preventDefault()}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </Stack>
  );
};

export default AppLabelComponent;
